import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Toolbar } from '@mui/material';
import { BsClockHistory } from 'react-icons/bs';
import { styled } from '@mui/material/styles';
import { SearchInput } from 'components';
import { ClientCarelist } from './client-care-list';
import { DrawerLeadWaitCare } from './drawer-lead-wait-care';
import ApiServices from 'services';
import { CLIENT_STATUS_ID, CLIENT_STATUS_NAME } from 'commons/constants';
import Utils from 'commons/utils';
import { BsArrowDownCircle } from 'react-icons/bs';
import moment from 'moment';

const ClientCareHistoryCurrent = () => {
  const { ACCEPT_DEAL, PROCESSING_DEAL, FILTER_LEAD } = CLIENT_STATUS_ID;
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [columns, setColumns] = useState({});
  const [columnsOriginCare, setColumnsOriginCare] = useState([]);
  const [columnsOriginDeal, setColumnsOriginDeal] = useState([]);
  const [columnsOriginDealSuccess, setColumnsOriginDealSuccess] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDataInit = async () => {
    let [getLeadsTakingCare, getDeals] = await Promise.all([
      ApiServices.getClientCareHistoryByStatus(ACCEPT_DEAL),
      ApiServices.getClientCareHistoryByStatus(PROCESSING_DEAL),
    ]);

    const mapDataCare = getLeadsTakingCare?.data?.map((item) => {
      item.textSearch = `${item?.objClientCompany?.code}${item?.objClientCompany?.name}`;
      return item;
    });
    const mapDataDeal = getDeals?.data?.map((item) => {
      item.textSearch = `${item?.objClientCompany?.code}${item?.objClientCompany?.name}`;
      return item;
    });

    setColumnsOriginCare(mapDataCare || []);
    setColumnsOriginDeal(mapDataDeal || []);

    setColumns({
      [ACCEPT_DEAL]: {
        name: CLIENT_STATUS_NAME['ACCEPT_DEAL'],
        items: mapDataCare || [],
        columnId: ACCEPT_DEAL,
      },
      [PROCESSING_DEAL]: {
        name: CLIENT_STATUS_NAME['PROCESSING_DEAL'],
        items: mapDataDeal || [],
        columnId: PROCESSING_DEAL,
      },
    });
  };

  React.useEffect(() => {
    getDataInit();
  }, []);

  const handleExport = async () => {
    setLoading(true);
    await ApiServices.exportLeadTakingCare(
      `?ClientStatusIds=${ACCEPT_DEAL}&ClientStatusIds=${PROCESSING_DEAL}`,
    )
      .then((res) => {
        if (res?.data) {
          Utils.exportTemplate(
            res?.data,
            `DS_Khach_Hang_Hien_Huu_${Utils.formatSimpleDate(moment())}.xlsx`,
          );
        }
      })
      .catch((err) => {
        console.log('Export Tempalte error:', err);
        window.UIMessage?.error('Tải thất bại !!!');
      });
    setLoading(false);
  };

  const handleFilterData = (query, dataInit, idColumn) => {
    let dataFilter = [];
    dataInit?.map((item) => {
      let checkFilter = true;
      if (query) {
        if (!Utils.convertValSearch(item?.textSearch)?.includes(Utils.convertValSearch(query))) {
          checkFilter = false;
        }
      }

      if (checkFilter) {
        dataFilter.push(item);
        return;
      } else {
        return;
      }
    });

    setColumns((prev) => {
      prev[idColumn].items = dataFilter;
      return { ...prev };
    });
  };

  const handleSearchColumn = (value, dataColumn, dataInit) => {
    switch (dataColumn.columnId) {
      case ACCEPT_DEAL:
        handleFilterData(value, dataInit, ACCEPT_DEAL);
        return;

      case PROCESSING_DEAL:
        handleFilterData(value, dataInit, PROCESSING_DEAL);
        return;

      case FILTER_LEAD:
        handleFilterData(value, dataInit, FILTER_LEAD);
        return;

      default:
        break;
    }
  };

  return (
    <>
      <Container>
        <Header>
          <Typography variant="h6" id="tableTitle" component="div">
            KHÁCH HÀNG HIỆN HỮU
          </Typography>
          <ContainerRight>
            <ButtonExport
              variant="outlined"
              startIcon={<BsArrowDownCircle />}
              onClick={handleExport}
            >
              Tải excel
            </ButtonExport>
          </ContainerRight>
          {/* <ContainerRight>
            <SearchInput sx={{ mr: 2 }} />
            <LeadWaitCare
              variant="contained"
              size="small"
              startIcon={<BsClockHistory />}
              onClick={() => setIsOpenDrawer(true)}
              // onMouseOver={() => console.log('')}
            >
              Chờ chăm sóc
            </LeadWaitCare>
          </ContainerRight> */}
        </Header>

        <ClientCarelist
          columns={columns}
          setColumns={setColumns}
          getDataInit={getDataInit}
          handleSearchColumn={handleSearchColumn}
          columnsOriginCare={columnsOriginCare}
          columnsOriginDeal={columnsOriginDeal}
          columnsOriginDealSuccess={columnsOriginDealSuccess}
        />
      </Container>

      <DrawerLeadWaitCare
        isOpen={isOpenDrawer}
        setIsOpen={setIsOpenDrawer}
        getDataInit={getDataInit}
      />
    </>
  );
};

export { ClientCareHistoryCurrent };

const Container = styled(Paper)(({ theme }) => ({
  width: '100%',
  mb: 1,
  position: 'relative',
  overflow: 'hidden',
}));

const Header = styled(Toolbar)(({ theme }) => ({
  pl: { sm: 2 },
  pr: { xs: 1, sm: 1 },
}));

const ContainerRight = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  mr: 2,
}));

const LeadWaitCare = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#F9A907',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  padding: '0px 16px',
}));
export const ButtonExport = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '10px',
  marginLeft: '8px',
  color: '#6C757D',
  border: '1px solid rgba(0, 0, 0, 0.4)',
  '.MuiButton-startIcon': {
    marginRight: '5px',
  },
}));
